<template>
  <div class="cart-workspace">
    <CustomerPanel
      :customer-name="customerName"
      :customers="customers"
      :selected-customer="selectedCustomer"
      @select="$emit('select-customer', $event)"
      @notes="openNotes"
    />

    <CartTableHeader />

    <PromotionFreeItemChoices
      :choices="promotionChoices"
      :selections="order.promotion_selections"
      :quantities="order.promotion_quantities"
      @select="$emit('select-free-item', $event)"
    />

    <CartItemList
      :items="order.cartItems"
      :currency="currency"
      @increase="$emit('increase-item', $event)"
      @decrease="$emit('decrease-item', $event)"
      @quantity-change="$emit('quantity-change-item', $event)"
      @remove="$emit('remove-item', $event)"
      @edit="$emit('edit-item', $event)"
    />

    <CartItemEditModal
      :visible="editVisible"
      :item="editingItem"
      :sale-codes="editSaleCodes"
      :loading="editLoading"
      :currency="currency"
      @cancel="$emit('cancel-edit-item')"
      @remove="$emit('remove-edit-item', $event)"
      @save="$emit('save-edit-item', $event)"
    />

    <OrderNotesModal
      :visible="notesVisible"
      :notes="order.remarks"
      @cancel="closeNotes"
      @save="saveNotes"
    />

    <CompletePaymentModal
      :visible="paymentVisible"
      :order="order"
      :customer-name="customerName"
      :currency="currency"
      :currencies="paymentCurrencies"
      :exchange-rates="exchangeRates"
      :payment-resources="paymentResources"
      :loading="paymentLoading"
      :saving="paymentSaving"
      :validation-errors="paymentValidationErrors"
      @cancel="$emit('cancel-payment')"
      @finish="$emit('finish-payment', $event)"
      @preview-receipt="$emit('preview-receipt', $event)"
      @discount-change="$emit('discount-change', $event)"
    />

    <CartFooter
      :item-count="itemCount"
      :subtotal="subtotal"
      :tax-total="taxTotal"
      :vat-rate="vatRate"
      :grand-total="grandTotal"
      :currency="currency"
      :pending-scan-count="pendingScanCount"
      @complete-payment="$emit('complete-payment')"
    />
  </div>
</template>

<script>
import CartFooter from './CartFooter.vue'
import CartItemList from './CartItemList.vue'
import CartItemEditModal from './CartItemEditModal.vue'
import OrderNotesModal from './OrderNotesModal.vue'
import CompletePaymentModal from './CompletePaymentModal.vue'
import CartTableHeader from './CartTableHeader.vue'
import CustomerPanel from './CustomerPanel.vue'
import PromotionFreeItemChoices from './PromotionFreeItemChoices.vue'

export default {
  name: 'CartWorkspace',
  components: {
    CartFooter,
    CartItemList,
    CartItemEditModal,
    OrderNotesModal,
    CompletePaymentModal,
    CartTableHeader,
    CustomerPanel,
    PromotionFreeItemChoices
  },
  data() {
    return {
      notesVisible: false
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleShortcut)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleShortcut)
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    itemCount: {
      type: Number,
      default: 0
    },
    subtotal: {
      type: Number,
      default: 0
    },
    taxTotal: {
      type: Number,
      default: 0
    },
    vatRate: {
      type: Number,
      default: 0
    },
    grandTotal: {
      type: Number,
      default: 0
    },
    customerName: {
      type: String,
      default: ''
    },
    customers: {
      type: Array,
      default: () => []
    },
    selectedCustomer: {
      type: Object,
      default: null
    },
    currency: {
      type: Object,
      default: () => ({})
    },
    editVisible: {
      type: Boolean,
      default: false
    },
    editingItem: {
      type: Object,
      default: null
    },
    editSaleCodes: {
      type: Array,
      default: () => []
    },
    editLoading: {
      type: Boolean,
      default: false
    },
    paymentVisible: {
      type: Boolean,
      default: false
    },
    paymentResources: {
      type: Object,
      default: () => ({ payment_methods: [], banks: [] })
    },
    paymentCurrencies: {
      type: Array,
      default: () => []
    },
    exchangeRates: {
      type: Array,
      default: () => []
    },
    paymentLoading: {
      type: Boolean,
      default: false
    },
    paymentSaving: {
      type: Boolean,
      default: false
    },
    paymentValidationErrors: {
      type: Object,
      default: () => ({})
    },
    promotionChoices: {
      type: Array,
      default: () => []
    },
    pendingScanCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleShortcut(event) {
      if (event.key !== 'F7') return

      event.preventDefault()
      this.openNotes()
    },
    openNotes() {
      this.notesVisible = true
    },
    closeNotes() {
      this.notesVisible = false
    },
    saveNotes(notes) {
      this.$emit('update-order-notes', notes)
      this.closeNotes()
    }
  }
}
</script>

<style scoped src="../../styles/cart-workspace.css"></style>
